const $ = window.$
import React from "react"
/**
 * Scrolls a base element to a specified offset
 * @param  {Number} top         offset from top
 * @param  {jQuery selector string} baseElement element which to scroll
 */
export function scroll(top=0, baseElement='html, body'){
  $(baseElement).animate({scrollTop: top}, 700)
}

/**
 * Scrolls a base element to the top of a child element on the dom. Note that we assume the
 * body is the base element, as we really only use it in that case.
 *
 * @param  {jQuery selector string} element     element to scroll to the top of
 * @param  {Number} headerOffset                this is needed to account for fixed top navbars and such. It defaults to the height of the global navbar
 */
export function scrollToElement(element='body', headerOffset=60){
  return scroll($(element).offset().top - headerOffset, 'html, body')
}


/**
 * Fades child elements in. Requires sass/studios/partials/shared/_fade.sass to be loaded
 *
 * PROPS:
 * delay (opt.): number of milleseconds to wait to start fade. Defaults to 100
 * triggerFade (opt.): boolean which starts the fade animation. Useful for changing content that doesn't mount.
 * onFadeEnd (opt.): Necessary when using 'triggerFade' -> lets parent know when the fade is over and to update 'triggerFade' to false
 * {children} (req.): Elements to fade in
 */
export class Fade extends React.Component {

	constructor(props){
		super(props)
		this.state = {
			hidden: true
		}
	}

	setVisible(){
		this.setState({
			hidden: false
		})
	}

	componentDidUpdate(prevProps, _prevState){
		if (!prevProps.triggerFade && this.props.triggerFade){
			this.triggerFade()
		}
	}

	triggerFade(){
		if (!this.state.hidden){
			this.setState({hidden: true})
		}
		window.setTimeout(this.setVisible.bind(this), this.props.delay || 100)
	}

	componentDidMount(){
		this.triggerFade()
	}

	onTransitionEnd(){
		if (this.props.onFadeEnd){
			this.props.onFadeEnd()
		}
	}

	render(){
		let className = "fade-in-wrapper"
		if (this.state.hidden){
			className += " fade-in-hidden"
		} else {
			className += " fade-in-visible"
		}

		return (
			<div className={className} onTransitionEnd={this.onTransitionEnd.bind(this)}>
				{this.props.children}
			</div>
		)
	}
}
